import { WsBaseRequest } from 'api/ws/WsRequest';
import { API_TOURNAMENT_APPLY } from 'api/notificationManager/methods';

export default class TournamentApplyRequest extends WsBaseRequest {
  constructor(tournamentID: number) {
    super(API_TOURNAMENT_APPLY, { id: tournamentID });
  }
}
